import classNames from 'classnames';
import React, { FC, memo } from 'react';
import { Outlet } from 'react-router-dom';
import { MainHeader } from 'widgets/MainHeader';
import { SpecialPromotionOpener, useSpecialPromotionModal } from 'features/SpecialPromotion';
import { useScreenBreakpoints } from 'shared/utils/hooks/useScreenBreakpoints';
import { useRole } from 'entities/User';
import { useBoxAlerts } from 'app/appState';

export const MainLayout: FC = memo(() => {
  const { showSpecialPromotion } = useSpecialPromotionModal();
  const { isDesktop } = useScreenBreakpoints();
  const { isCustomer } = useRole();

  useBoxAlerts();

  const marginAmount = isDesktop ? 'mt-16' : 'mt-24';

  return (
    <div className={classNames({ [marginAmount]: isCustomer && showSpecialPromotion })}>
      <div className="wrapper">
        {isCustomer && <SpecialPromotionOpener eventTheme="easter" />}
        <MainHeader />
        <main className="min-h-[calc(100vh-theme(spacing.headerHeight))] pb-16 desktop:pb-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
});
